import 'bootstrap/dist/css/bootstrap.min.css';

import { init as initFullStory } from '@fullstory/browser';
import { LicenseInfo } from '@mui/x-license';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { HashRouter } from 'react-router-dom';

import AuthProvider from './contexts/AuthContext';
import BrandProvider from './contexts/BrandContext';
import HeaderProvider from './contexts/HeaderContext';
import ToastProvider from './contexts/ToastContext';
import SiteRoutes from './Routes';
import { NotificationsProvider } from './ui-components/notifications/NotificationsProvider';

LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE_KEY || '');

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false, retry: false } },
});

if (process.env.NODE_ENV === 'production') {
  initFullStory({ orgId: process.env.REACT_APP_FULLSTORY_ID ?? '' });
}

const App = () => {
  return (
    <HashRouter>
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          <AuthProvider>
            <HeaderProvider>
              <BrandProvider>
                <SiteRoutes />
                <NotificationsProvider />
              </BrandProvider>
            </HeaderProvider>
          </AuthProvider>
        </ToastProvider>
      </QueryClientProvider>
    </HashRouter>
  );
};

export default App;
